module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_3016.de62b7ab.png";